<div class="privacy-page f-p">
  <div class="row">
    <div class="col-12 privacy-page-bg">
      <div class="container-xl">
        <h2>Privacy Policy</h2>
        <div class="white-bg">
          <p>
            Kunnect, LLC (“Kunnect,” “we,” “us,” or “our”) respects your privacy
            and is committed to protecting the information you provide when
            using our services. This Privacy Policy explains how we collect,
            use, and safeguard your information and outlines your choices
            regarding its use.
          </p>
          <h6>1. Information We Collect</h6>
          <p class="lh-normal">
            We collect information in various ways to improve our services and
            support your experience with Kunnect. This includes:
          </p>
          <ul>
            <li>
              Information You Provide Directly - When you create an account,
              engage with our services, contact us, or participate in
              promotions.
            </li>
            <li>
              Automatically Collected Information - Such as website activity,
              device details, and browsing behaviour via cookies and similar
              technologies.
            </li>
            <li>
              Third-Party Data - We may receive information from business
              partners or service providers to enhance our offerings.
            </li>
          </ul>
          <p>
            We collect and process this data in a manner consistent with
            industry standards and applicable legal requirements.
          </p>
          <h6>2. How We Use Your Information</h6>
          <p class="lh-normal">
            Kunnect may use collected information for various business purposes,
            including:
          </p>
          <ul>
            <li>
              Providing and Managing Services - Delivering and improving our
              products, services, and customer experience.
            </li>
            <li>
              Enhancing Security - Maintaining the integrity and security of our
              systems.
            </li>
            <li>
              Analytics & Optimization - Understanding usage patterns to refine
              our services.
            </li>
            <li>
              Legal Compliance & Obligations - Adhering to applicable
              regulations and responding to lawful requests.
            </li>
            <li>
              Marketing & Communications - Sending relevant service updates or
              promotional materials (where permitted by law and user
              preferences).
            </li>
          </ul>
          <p>
            We balance our business interests with our commitment to privacy,
            and we take steps to ensure any data use aligns with expectations
            and best practices.
          </p>
          <h6>3. Data Protection & Security</h6>
          <p>
            We implement reasonable safeguards to help protect your data from
            unauthorized access, loss, or misuse. These measures include
            industry-recognized security practices, though no system can
            guarantee complete security. We continuously evaluate our security
            protocols to align with evolving standards and legal requirements.
            However, we encourage users to take precautions, such as
            safeguarding account credentials and exercising caution when sharing
            personal information online.
          </p>
          <h6>4. Data Sharing & Third Parties</h6>
          <p class="lh-normal">
            We do not sell your personal data. However, we may share information
            in the following scenarios:
          </p>
          <ul>
            <li>
              Service Providers & Partners - With trusted entities that assist
              in delivering our services.
            </li>
            <li>
              Business Operations - As part of strategic business initiatives,
              including partnerships, mergers, or acquisitions.
            </li>
            <li>
              Legal & Compliance Needs - To comply with laws, enforce
              agreements, or protect our rights, property, or users.
            </li>
          </ul>
          <p>
            Any third-party relationships involving data are subject to
            reasonable safeguards to maintain privacy and security.
          </p>
          <h6>5. Data Retention & Your Rights</h6>
          <p class="mb-0">
            We retain data for as long as reasonably necessary to fulfill the
            purposes outlined in this policy, comply with legal obligations, or
            support legitimate business operations. Retention periods vary based
            on factors such as account activity, business needs, and regulatory
            requirements.
          </p>
          <p>
            Where applicable, you may have rights related to your personal data,
            including access, correction, deletion, or restriction of certain
            uses. Requests will be reviewed on a case-by-case basis in
            accordance with applicable laws. If you wish to exercise these
            rights, please contact us at helpdesk&#64;ikunnect.com.
          </p>
          <h6>6. Cookies & Tracking Technologies</h6>
          <p class="lh-normal">
            Kunnect uses cookies and similar tracking tools to enhance user
            experience, analyze website performance, and improve our services.
            These technologies may help:
          </p>
          <ul>
            <li>
              Remember user preferences for a more personalized experience.
            </li>
            <li>Analyze trends to optimize website functionality.</li>
            <li>Provide relevant marketing and advertising (as permitted).</li>
          </ul>
          <p>
            Users may adjust browser settings to control or disable cookies,
            though doing so may impact certain features of our website.
          </p>
          <h6>7. International Data Transfers</h6>
          <p>
            Depending on your location and the services you use, your data may
            be transferred to and processed in jurisdictions with differing
            privacy protections. We take appropriate steps to ensure that such
            transfers comply with relevant legal frameworks and that data
            remains protected in accordance with applicable laws.
          </p>
          <h6>8. Data Breach Response</h6>
          <p>
            While we strive to maintain the security of our systems, unforeseen
            incidents may occur. In the unlikely event of a data breach that
            poses a risk to user privacy, we will take reasonable steps to
            assess, mitigate, and, where appropriate, notify affected parties in
            accordance with applicable laws.
          </p>
          <h6>9. Children's Privacy</h6>
          <p>
            Kunnect’s services are not directed at children under a certain age,
            and we do not knowingly collect personal data from minors. If we
            become aware that we have inadvertently collected such information,
            we will take appropriate steps to remove it.
          </p>
          <h6>10. Updates to This Policy</h6>
          <p>
            We may update this Privacy Policy periodically to reflect changes in
            our services, legal requirements, or industry practices. Any changes
            will be posted on this page with an updated Effective Date.
            Continued use of our services after updates constitutes acceptance
            of the revised policy.
          </p>
        </div>
      </div>
    </div>
    <app-book-consultation [title]="title" class="spa0 col-12" />
  </div>
</div>
